export const createIssuanceRequestMutation = `#graphql
  mutation CreateIssuanceRequest($request: IssuanceRequestInput!) {
    createIssuanceRequest(request: $request) {
      ... on IssuanceResponse {
        requestId
        url
        qrCode
        expiry
      }
      ... on RequestErrorResponse {
        error {
          code
          message
          innererror {
            code
            message
            target
          }
        }
      }
    }
  }
`

export const issuanceEventSubscription = `#graphql
  subscription IssuanceEvent($requestId: ID!) {
    issuanceEvent(where: {requestId: $requestId}) {
      event {
        requestStatus
        error {
          code
          message
        }
      }
      issuance {
        id
        issuedAt
        expiresAt
        contract {
          id
          name
          credentialTypes
          display {
            card {
              title
              issuedBy
              backgroundColor
              textColor
              description
              logo {
                uri
                description
              }
            }
          }
        }
      }
    }
  }
`

export const findIssuanceQuery = `#graphql
  query FindIssuance($requestId: ID!) {
    findIssuances(where: { requestId: $requestId }, limit: 1) {
      id
      issuedAt
      expiresAt
      contract {
        id
        name
        credentialTypes
        display {
          card {
            title
            issuedBy
            backgroundColor
            textColor
            description
            logo {
              uri
              description
            }
          }
        }
      }
    }
  }
`

export const createPresentationRequestMutation = `#graphql
  mutation CreatePresentationRequest($request: PresentationRequestInput!) {
    createPresentationRequest(request: $request) {
      ... on PresentationResponse {
        requestId
        url
        expiry
        qrCode
      }
      ... on RequestErrorResponse {
        requestId
        date
        mscv
        error {
          code
          message
          innererror {
            code
            message
            target
          }
        }
      }
    }
  }
`

export const createPresentationRequestForAuthnMutation = `#graphql
mutation CreatePresentationRequestForAuthn {
  createPresentationRequestForAuthn {
    ... on PresentationResponse {
      requestId
      url
      expiry
      qrCode
    }
    ... on RequestErrorResponse {
      requestId
      date
      mscv
      error {
        code
        message
        innererror {
          code
          message
          target
        }
      }
    }
  }
}
`

export const presentationEventSubscription = `#graphql
  subscription PresentationEvent($requestId: ID!) {
    presentationEvent(where: { requestId: $requestId }) {
      event {
        requestStatus
        error {
          code
          message
        }
      }
      presentation {
        id
        presentedAt
        identity {
          id
          identifier
          issuer
          name
        }
        presentedCredentials {
          issuer
          type
          claims
          credentialState
          domainValidation
        }
        issuances {
          id
          status
          issuedAt
          expiresAt
          revokedAt
          contract {
            id
            name
            credentialTypes
            display {
              card {
                title
                issuedBy
                backgroundColor
                textColor
                description
                logo {
                  uri
                  description
                }
              }
            }
          }
        }
        partners {
          id
          did
          name
          credentialTypes
          linkedDomainUrls
        }
      }
    }
  }
`

export const findPresentationQuery = `#graphql
  query FindPresentations($requestId: ID!) {
    findPresentations(where: { requestId: $requestId }, limit: 1) {
      id
      presentedAt
      identity {
        id
        identifier
        issuer
        name
      }
      presentedCredentials {
        issuer
        type
        claims
        credentialState
        domainValidation
      }
      issuances {
        id
        status
        issuedAt
        expiresAt
        revokedAt
        contract {
          id
          name
          credentialTypes
          display {
            card {
              title
              issuedBy
              backgroundColor
              textColor
              description
              logo {
                uri
                description
              }
            }
          }
        }
      }
      partners {
        id
        did
        name
        credentialTypes
        linkedDomainUrls
      }
    }
  }
`

export const createPhotoCaptureRequestMutation = `#graphql
  mutation CreatePhotoCaptureRequest($request: PhotoCaptureRequest!) {
  createPhotoCaptureRequest(request: $request) {
    id
    photoCaptureQrCode
    photoCaptureUrl
  }
}
`

export const photoCaptureEventSubscription = `#graphql
subscription PhotoCaptureEvent($photoCaptureRequestId: UUID!) {
  photoCaptureEvent(photoCaptureRequestId: $photoCaptureRequestId) {
    status
  }
}
`

export const photoCaptureStatusQuery = `#graphql
query PhotoCaptureStatus($photoCaptureRequestId: UUID!) {
  photoCaptureStatus(photoCaptureRequestId: $photoCaptureRequestId) {
    status
  }
}
`
